import { ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";

export interface Goal {
    id: number;
    cycleParticipantId: number;
    creationUserId: string;
    title: string;
    description: string;
    weight: number;
    managerComment?: string;
    userImgUrl?: string;
    userName?: string;
    currentProgress?: number;
    approved?: boolean;

    deadline: Date;
    initialDeadline: Date;
    lastVersion: Goal;
    type: GoalType;
    processType: ProcessTypeEnum;
    status: GoalStatusEnum;
    
    field1: string;
    field2: string;
    field3: string;
    field4: string;
    field5: string;
    field6: string;
    field7: string;
    field8: string;
    field9: string;
    field10: string;
}

export enum GoalStatusEnum {
    Draft = 0,
    WaitingForApproval = 1,
    Rejected = 2,
    Approved = 3,
    DraftForReview = 4,
    SentForReview = 5,
    ReviewRejected = 6,
    ReviewAccepted = 7
}

export enum GoalType {
    Revenue = 1
}
